﻿const history = window.History;

function buildUpQueryString(data) {
    const queryStringData = {};
    $.map(data,
        function (value, key) {
            if (key === "isPageChange")
                return;
            if (value) {
                queryStringData[key] = value;
            }
        });
    return $.param(queryStringData).replace(/%5B%5D/g, "");
}

function getData() {
    const dataArray = $("[data-car-tax-query-attributes] :input").serializeArray();
    const data = {};
    dataArray.map(function (item) {
        if (data[item.name]) {
            if (typeof (data[item.name]) === "string") {
                data[item.name] = [data[item.name]];
            }
            data[item.name].push(item.value);
        } else {
            data[item.name] = item.value;
        }
    });
    return data;
}

function updateResultsLogic(isPageChange) {
    const data = getData();
    if (isPageChange) {
        data.isPageChange = true;
    }
    history.pushState(data, $("title").html(), location.pathname + "?" + buildUpQueryString(data));
    return data;
}


function triggerUpdateResults(event) {
    if (event.target.name === "Manufacturer1Id") {
        if ($("#ModelGroup1Id").val() !== null) {
            $("#ModelGroup1Id").val("");
            $("#Derivative1Id").val("");
        }
    }
    if (event.target.name === "ModelGroup1Id") {
        if ($("#Derivative1Id").val() !== null) {
            $("#Derivative1Id").val("");
        }
    }
    window.updateResults();
}

function reloadQuery() {
    const state = history.getState();
    $.get('/costs/new-car-tax-calculator/query', state.data, function (response) {
        $('[data-car-tax-query-attributes]').replaceWith(response);
    });
}

function updateState() { // Note: We are using statechange instead of popstate
    reloadQuery();
    const state = history.getState();
    $.get('/costs/new-car-tax-calculator/results', state.data, function (response) {
        $('[data-car-tax-results-container]').replaceWith(response);
        if (window.isViewportLessThan('lg')) {
            $(".first-car-tax-result").insertAfter($(".first-car-tax-query"));
            $(".second-car-tax-result").insertAfter($(".second-car-tax-query"));
        }
    });
}

function moveElements() {
    if (window.isViewportLessThan('lg')) {
        $(".first-car-tax-result").insertAfter($(".first-car-tax-query"));
        $(".second-car-tax-result").insertAfter($(".second-car-tax-query"));
    }
}

export function setupNewCarTaxCalculator() {
    if ($('[data-new-car-tax-calculator]').length) {
        $(document)
            .on("change",
                "[data-car-tax-query-attributes] input, [data-car-tax-query-attributes] select",
                triggerUpdateResults);
        // Bind to StateChange Event
        history.Adapter.bind(window, "statechange", updateState);
        moveElements();
        $(window).on('resize', moveElements);

        window.updateResults = function () {
            updateResultsLogic();
        };
    }
}